import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import Granim from "granim";
// import "../styles/index.css"
import { Parallax } from 'react-parallax';

let image = "https://images.pexels.com/photos/768900/pexels-photo-768900.jpeg?cs=srgb&dl=pexels-irina-iriser-768900.jpg&fm=jpg"

export const QuoteParallaxTwo = () => {
  useEffect(() => {

  }, []);
  return (
    <>
      <Parallax blur={1} bgImage={image} bgImageAlt="the cat" strength={400} className="parallax-quote align-items-center d-flex justify-content-center">
       <div className="quote-parralax-two"><h4 className="quote-text ">
       <i class="fas fa-quote-left"></i>Lo que niegas te somete lo que aceptas te transforma<i class="fas fa-quote-right"></i></h4>
       <p className="text-autor Licorice">-Carl Jung</p>
       </div>
    </Parallax>
    </>
  );
};
